import React, { useEffect, useState, useRef, useCallback } from "react";
import FullPageSpinner from "../layout/FullPageSpinner";
import { Modal, Button, Form, Table } from "react-bootstrap";
import {
  fetchAllOrders,
  generateOrderSlipsPdf,
  printAllOrderSlipsApi,
  updateOrderStatus,
  updateTransactionStatus,
  getProductsByIds,
  getSizesInBulk,
  bulkUpdateTransactionStatus,
  bulkUpdateDeliveryStatus,
  fetchAcademicYears,
  checkIciciStatus,
  fetchOrderById,
  fetchOrderStatusList,
  generateDtdcOrder,
  cancelDtdcOrder,
  fetchDtdcLabel,
  fetchDtdcTracking,
  exportOrdersToCSVApi,
  exportOrdersToExcelApi,
  fetchBulkPreview,
  fetchOrderStats,
  copyOrder,
  fetchInvoicePdfBlob
} from "../../actions/product";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import OrderDetails from "./OrderDetails";
import UpdateOrderAddressModal from "./UpdateOrderAddressModal";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../services/helper";
import { ROLES } from "../../utils/constants";
import { utils, read } from "xlsx";
import { ORDER_TYPES, ROLE_ORDER_TYPES } from "../../utils/orderTypes";

const OrderManagement = ({ isVendor = false, isStore = false }) => {
  const { user } = useSelector(
    (state) => state.auth
  );

  const hasPermission = (permission) => {
    if (user?.role === ROLES.SUPER_ADMIN) return true;
    return user?.permissions?.[permission] === true;
  };
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [settlementStatus, setSettlementStatus] = useState("SETTLED");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [paymentstatusFilter, setPaymentstatusFilter] = useState("");
  const [barcode, setBarcode] = useState("");
  const [applicationCode, setApplicationCode] = useState("");
  const barcodeInputRef = React.useRef(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [sortKey, setSortKey] = useState("order.createdAt");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [orderType, setOrderType] = useState(ORDER_TYPES.ORIGINAL);
  const [itemCategoryFilter, setItemCategoryFilter] = useState("");

  useEffect(() => {
    if (user?.role) {
      const allowedTypes = ROLE_ORDER_TYPES[user.role] || [];
      if (allowedTypes.length === 1) {
        setOrderType(allowedTypes[0]);
      } else if (user.role === ROLES.ADMIN || user.role === ROLES.SUPER_ADMIN || user.role === ROLES.STORES) {
        setOrderType(ORDER_TYPES.ORIGINAL);
      }
    }
  }, [user?.role]);
  const [uploadStatus, setUploadStatus] = useState({
    show: false,
    success: 0,
    failed: 0,
    errors: []
  });
  const [pdfPreview, setPdfPreview] = useState({
    show: false,
    url: "",
    blob: null,
    fileName: ""
  });
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [ordersMap, setOrdersMap] = useState({});
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkStatus, setBulkStatus] = useState("");
  const [academicYears, setAcademicYears] = useState([]);
  const [orderStatusList, setOderStatusList] = useState([]);
  const [currentYear, setCurrentYear] = useState();
  const [showExportModal, setShowExportModal] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingData, setTrackingData] = useState(null);
  const [fetchingTracking, setFetchingTracking] = useState(false);
  const [showCsvPreviewModal, setShowCsvPreviewModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [bulkUploadStatus, setBulkUploadStatus] = useState("ARRIVED_AT_WAREHOUSE");
  const [previewDetails, setPreviewDetails] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [orderStats, setOrderStats] = useState({ statusStats: [], transactionStats: [] });
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [copySuffix, setCopySuffix] = useState("/S");
  const [statusNote, setStatusNote] = useState("");
  const [slipExportType, setSlipExportType] = useState("non-shoes");
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addressOrder, setAddressOrder] = useState(null);

  const handleOpenAddressModal = async (order) => {
    setLoading(true);
    try {
      const fetched = await fetchOrderById(order.id);
      setAddressOrder(fetched || order);
      setShowAddressModal(true);
    } catch (err) {
      setAddressOrder(order);
      setShowAddressModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressUpdated = (updatedOrder) => {
    if (selectedOrder && selectedOrder.id === updatedOrder.id) {
      setSelectedOrder((prev) => ({ ...prev, ...updatedOrder }));
    }
    getOrders();
  };

  const handleCopyOrder = async () => {
    if (!selectedOrder) return;
    setLoading(true);
    try {
      await copyOrder(selectedOrder.id, copySuffix, 0.01);
      setShowCopyModal(false);
      setShowModal(false);
      getOrders();
    } catch (error) {
      setShowCopyModal(false);
      setShowModal(false);
      getOrders();
      console.error("Error duplicating order:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStats = useCallback(async () => {
    if (user?.role !== ROLES.SUPER_ADMIN) return;
    try {
      const stats = await fetchOrderStats(searchTerm, startDate, endDate, currentYear);
      if (stats) {
        setOrderStats(stats);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  }, [searchTerm, startDate, endDate, currentYear, user?.role]);

  useEffect(() => {
    getStats();
  }, [getStats]);

  const handleCsvBulkUpdate = async () => {
    if (!bulkUploadStatus) {
      toast.warning("Please select a status");
      return;
    }

    setLoading(true);
    try {
      const transformedData = {
        transactions: csvData.map((row) => ({
          orderId: row['Order ID'],
          status: bulkUploadStatus,
        })),
      };

      const response = await bulkUpdateDeliveryStatus(transformedData);

      setUploadStatus({
        show: true,
        success: response.successCount || 0,
        failed: response.failedCount || 0,
        errors: [response.message],
      });

      setShowCsvPreviewModal(false);
      setCsvData([]);
      setPreviewDetails([]);
      getOrders();
    } catch (error) {
      console.error("Error in CSV bulk update:", error);
      toast.error("Failed to update orders from CSV");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    setLoading(true);
    try {
      const academicYearsRes = await fetchAcademicYears();
      const orderStatusList = await fetchOrderStatusList();

      if (orderStatusList) {
        setOderStatusList(orderStatusList);
      }

      if (academicYearsRes) {
        setAcademicYears(academicYearsRes);

        // find current year using is_current flag
        const current =
          academicYearsRes.find(
            (year) => year.is_current === true
          ) || academicYearsRes[0];
        setCurrentYear(current.year)
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
    } finally {
      setLoading(false);
    }
  };

  const selectableOrders = orders.filter(
    o => o?.status && o.status !== "DELIVERED" && o.transactionStatus !== "PENDING"
  );

  const toggleSelectAll = () => {
    const allOnPageSelected = selectableOrders.length > 0 && selectableOrders.every(o => selectedOrders.includes(o.id));
    
    if (allOnPageSelected) {
      // Unselect all on current page
      const selectableIds = selectableOrders.map(o => o.id);
      setSelectedOrders(prev => prev.filter(id => !selectableIds.includes(id)));
    } else {
      // Select all on current page
      const selectableIds = selectableOrders.map(o => o.id);
      setSelectedOrders(prev => {
        const newSelection = [...prev];
        selectableIds.forEach(id => {
          if (!newSelection.includes(id)) {
            newSelection.push(id);
          }
        });
        return newSelection;
      });
    }
  };

  const handleSelectOrder = (id) => {
    const order = orders.find(o => o.id === id);
    if (order?.status === "DELIVERED" || order?.transactionStatus === "PENDING") return; // 🚫 block

    setSelectedOrders(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const isAdmin = user?.role === "admin";
  const isStoreAdmin = user?.role === "stores";
  const isSuperadmin = user?.role === "superadmin";
  const isAccounts = user?.role === "accounts";
  const isVendorAcc = user?.role === "vendor";
  
  const canUpdateStatus = hasPermission('order_status_update');
  const canViewOrderDetails = hasPermission('order_details_view');
  const canPrintAllSlips = hasPermission('order_all_print');
  const canPrintOrderSlips = hasPermission('print_order_payment_slips');
  const canExportOrders = hasPermission('order_export');
  const canBulkUpload = hasPermission('order_bulk_upload') || isStoreAdmin;
  const canEditOrder = hasPermission('order_edit');
  
  const filterByPayment  = isAdmin || isStoreAdmin || isSuperadmin;

  const handleBulkStatusUpdate = async () => {
    if (!canUpdateStatus) {
      toast.error("You do not have permission to perform this action");
      return;
    }
    if (selectedOrders.length === 0) {
      toast.warning("Please select at least one order");
      return;
    }
    if (!bulkStatus) {
      toast.warning("Please select a status");
      return;
    }

    setLoading(true);
    try {
      const transformedData = {
        transactions: selectedOrders.map((id) => ({
          orderId: id,
          status: bulkStatus,
          note: statusNote,
        })),
      };

      const response = await bulkUpdateDeliveryStatus(transformedData);

      if (response.success) {
        toast.success(response.message || "Bulk status updated successfully");
        setShowBulkModal(false);
        setSelectedOrders([]);
        setBulkStatus("");
        getOrders();
      } else {
        toast.error(response.message || "Bulk update partially failed");
      }
    } catch (error) {
      console.error("Error in bulk status update:", error);
      toast.error(error.response?.data?.message || "Failed to update bulk status");
    } finally {
      setLoading(false);
    }
  };

  const getOrders = useCallback(async () => {
    setLoading(true);
    try {
      if (currentYear) {
        const response = await fetchAllOrders(
          currentPage,
          itemsPerPage,
          searchTerm,
          startDate,
          endDate,
          statusFilter,
          paymentstatusFilter,
          settlementStatus,
          isVendor,
          sortKey,
          sortOrder,
          currentYear,
          "false",
          "non-shoes",
          orderType,
          itemCategoryFilter
        );

        setOrders(response.orders || []);
        setTotalPages(response.totalPages || 1);
        setTotalItems(response.total);
      }
    } catch (error) {
      setOrders([]);
      setTotalPages(1);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    itemsPerPage,
    startDate,
    endDate,
    statusFilter,
    paymentstatusFilter,
    settlementStatus,
    isVendor,
    searchTerm,
    sortKey,
    sortOrder,
    currentYear,
    orderType,
    itemCategoryFilter
  ]);

  useEffect(() => {
    getOrders();
  }, [getOrders]);
  
  // Maintain a map of all seen orders so their details can be accessed even when off-page
  useEffect(() => {
    setOrdersMap(prev => {
      const newMap = { ...prev };
      orders.forEach(o => { newMap[o.id] = o; });
      return newMap;
    });
  }, [orders]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, startDate, endDate, statusFilter, paymentstatusFilter, settlementStatus, itemCategoryFilter]);

  useEffect(() => {
  }, [currentPage]);

  const onView = async (order) => {
    setLoading(true);
    try {
      const fetchedOrder = await fetchOrderById(order.id);
      if (fetchedOrder) {
        setSelectedOrder(fetchedOrder);
        setNewStatus(isVendor ? fetchedOrder.status : fetchedOrder.transactionStatus);
        setSettlementStatus(fetchedOrder.settlement_status);
        setBarcode(fetchedOrder.trackingId || "");
        setApplicationCode(fetchedOrder.payments[0]?.applicationCode || "");
        setStatusNote("");
        setShowModal(true);
      } else {
        toast.error("Failed to fetch order details");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      toast.error("Error fetching order details");
    } finally {
      setLoading(false);
    }
  };

  const onManageDelivery = async (order) => {
    setLoading(true);
    // setSelectedOrder(order);
    setShowDetailsModal(true)
    setSelectedOrderId(order.id)
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortKey(key);
      setSortOrder("ASC");
    }
  };

  const renderSortArrow = (key) => {
    if (sortKey === key) {
      return sortOrder === "ASC" ? " 🔼" : " 🔽";
    }
    return null;
  };

  const handleCheckIciciStatus = async (orderId) => {
    setLoading(true);
    try {
      const response = await checkIciciStatus(orderId);
      if (response) {
        toast.success(response.message || "ICICI status checked successfully");
      } else {
        toast.error(response?.message || "Failed to check ICICI status");
      }
    } catch (error) {
      console.error("Error checking ICICI status:", error);
      toast.error("Error checking ICICI status");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async () => {
    if (!selectedOrder) return;
    setLoading(true);
    try {
      if (isVendor) {
        await updateOrderStatus(selectedOrder.id, { status: newStatus, trackingId: barcode, note: statusNote });
      } else {
        await updateTransactionStatus(selectedOrder.id, newStatus, settlementStatus, applicationCode);
      }
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === selectedOrder.id
            ? isVendor
              ? { ...order, status: newStatus, trackingId: barcode, note: statusNote }
              : { ...order, transactionStatus: newStatus, payments: [{ ...order.payments[0], status: newStatus, applicationCode: applicationCode }], settlement_status: settlementStatus }
            : order
        )
      );
      toast.success("Status updated successfully");
      setShowModal(false);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error.response?.data?.message || error.message || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateDtdc = async () => {
    if (!selectedOrder) return;
    setLoading(true);
    try {
      await generateDtdcOrder(selectedOrder.id);
      const updatedOrder = await fetchOrderById(selectedOrder.id);
      if (updatedOrder) {
        setSelectedOrder(updatedOrder);
        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.id === selectedOrder.id ? updatedOrder : order
          )
        );
        // Automatically open Tax Invoice with tracking barcode
        try {
          console.log(updatedOrder)
          const blob = await fetchInvoicePdfBlob(updatedOrder.id);
          const url = URL.createObjectURL(blob);
          setPdfPreview({
            show: true,
            url: url,
            blob: blob,
            fileName: `Tax_Invoice_${updatedOrder.orderId || updatedOrder.id}.pdf`
          });
          toast.success("DTDC Order shipped! Tax Invoice with tracking barcode is ready.");
        } catch (pdfErr) {
          console.error("Error auto-opening invoice PDF:", pdfErr);
        }
      }
    } catch (error) {
      console.error("Error generating DTDC order:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDtdc = async () => {
    if (!selectedOrder) return;
    if (!window.confirm("Are you sure you want to cancel this DTDC order?")) return;

    setLoading(true);
    try {
      await cancelDtdcOrder(selectedOrder.id);
      const updatedOrder = await fetchOrderById(selectedOrder.id);
      if (updatedOrder) {
        setSelectedOrder(updatedOrder);
        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.id === selectedOrder.id ? updatedOrder : order
          )
        );
      }
    } catch (error) {
      console.error("Error cancelling DTDC order:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewTracking = async () => {
    if (!selectedOrder) return;
    setFetchingTracking(true);
    try {
      const data = await fetchDtdcTracking(selectedOrder.id);
      setTrackingData(data);
      setShowTrackingModal(true);
    } catch (error) {
      console.error("Error fetching tracking details:", error);
    } finally {
      setFetchingTracking(false);
    }
  };

  const handleReset = () => {
    setSearchTerm("");
    setStartDate("");
    setEndDate("");
    setStatusFilter("");
    setPaymentstatusFilter("");
    setSettlementStatus("SETTLED");
    setItemCategoryFilter("");
    setSlipExportType("non-shoes");
    setCurrentPage(1);
    // Find and set current year again
    const current = academicYears.find((year) => year.is_current === true) || academicYears[0];
    if (current) setCurrentYear(current.year);
    getOrders();
  };

  const [showLabelModal, setShowLabelModal] = useState(false);
  const [printOrderId, setPrintOrderId] = useState(null);

  const labelOptions = [
    { label: "Shipping Label A4", value: "SHIP_LABEL_A4" },
    { label: "Shipping Label A6", value: "SHIP_LABEL_A6" },
    { label: "Shipping Label POD", value: "SHIP_LABEL_POD" },
    { label: "Shipping Label 4x6", value: "SHIP_LABEL_4X6" },
    { label: "Routing Label A4", value: "ROUTE_LABEL_A4" },
    { label: "Routing Label 4x4", value: "ROUTE_LABEL_4X4" }
  ];

  const handlePrintLabelClick = (orderId) => {
    setPrintOrderId(orderId);
    setShowLabelModal(true);
  };

  const handlePrintLabel = async (labelCode) => {
    const id = printOrderId || selectedOrder?.id;
    if (!id) return;

    setShowLabelModal(false);
    setLoading(true);
    try {
      const response = await fetchDtdcLabel(id, labelCode);
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      setPdfPreview({
        show: true,
        url: url,
        blob: blob,
        fileName: `DTDC_Label_${id}.pdf`
      });
    } catch (error) {
      console.error("Error fetching DTDC label:", error);
      toast.error("Failed to fetch DTDC label");
    } finally {
      setLoading(false);
    }
  };


  const exportToCSVNew = async (exportType) => {
    setLoading(true);

    try {
      const blob = await exportOrdersToCSVApi(
        searchTerm,
        startDate,
        endDate,
        statusFilter,
        paymentstatusFilter,
        settlementStatus,
        isVendor,
        sortKey,
        sortOrder,
        currentYear,
        exportType,
        orderType
      );

      if (blob && (blob.size > 0 || blob.length > 0)) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Order_Details.csv`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);
        toast.success("CSV exported successfully");
      } else {
        toast.warning("No data found to export");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data");
    } finally {
      setLoading(false);
    }
  };


  const printOrderSlip = async (orderItem) => {
    setLoading(true);
    try {
      const order = await fetchOrderById(orderItem.id);
      if (!order) {
        toast.error("Failed to fetch order details for printing");
        return;
      }
      const allProductIds = [];
      const studentProductMap = {};

      order.items.forEach(item => {
        if (item.bundle && item.bundle.bundleProducts) {
          item.bundle.bundleProducts.forEach(product => {
            if (product.productId) {
              if (!allProductIds.includes(product.productId)) allProductIds.push(product.productId);
              if (studentProductMap[item?.student?.id]?.length) {
                studentProductMap[item.student.id].push(product.productId);
              } else {
                studentProductMap[item.student.id] = [product.productId];
              }
            }
          });
        }
      });

      // Create a new PDF
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      let currentY = 0;
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const halfPageHeight = pageHeight / 2;

      // Group items by student to ensure single slip per student for multiple items/single products
      const studentMap = {};
      (order.items || []).forEach((item) => {
        const student = item.student || {};
        const studentKey =
          student.id || student.usid || item.studentId || "default";
        if (!studentMap[studentKey]) {
          studentMap[studentKey] = {
            student: student,
            items: [],
          };
        }
        studentMap[studentKey].items.push(item);
      });

      const studentEntries = Object.values(studentMap);

      // Generate a slip for each unique student in the order
      for (let studentIndex = 0; studentIndex < studentEntries.length; studentIndex++) {
        const { student, items } = studentEntries[studentIndex];

        // Create temporary container for HTML template
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '-9999px';
        tempDiv.style.width = '210mm'; // A4 width
        tempDiv.style.margin = '0';
        tempDiv.style.padding = '0';
        document.body.appendChild(tempDiv);

        // Build product rows for this specific student
        let productRowsHtml = '';
        let productCount = 0;
        const productRows = [];

        for (const item of items) {
          if (!item.bundle?.isIndividualProduct) {
            (item.orderItemProducts || []).forEach((product) => {
              if (product.totalQuantity > 0) {
                let productName = product.product?.name || "";

                if (
                  product.product?.display_name === "Sports V Collar T-Shirt" ||
                  product.product?.name ===
                    "TGS Uni V Collar Slate HD Tee - 4 Colors" ||
                  product.product?.name === "Sports CC T-Shirt" ||
                  product.product?.name === "TGS Uni CC Slate Tee - 4 Colors"
                ) {
                  const house = student.house;
                  if (house === "Dragons") {
                    productName = productName.replace("4 Colors", "Red");
                  }
                  if (house === "Pegasus") {
                    productName = productName.replace("4 Colors", "Blue");
                  }
                  if (house === "Sphinx") {
                    productName = productName.replace("4 Colors", "Yellow");
                  }
                  if (house === "Griffins") {
                    productName = productName.replace("4 Colors", "Green");
                  }
                }

                productRows.push({
                  name:
                    (product.product?.display_name
                      ? `${product.product.display_name} (${productName || product.product.name})`
                      : productName || product.product?.name) || '',
                  size: product.size || '-',
                  quantity: product.totalQuantity,
                });
              }
            });
          } else if (item.orderItemProducts && item.orderItemProducts.length > 0) {
            item.orderItemProducts.forEach((product) => {
              if (product.totalQuantity > 0) {
                let productName = product.product?.name || "";

                if (
                  product.product?.display_name === "Sports V Collar T-Shirt" ||
                  product.product?.name ===
                    "TGS Uni V Collar Slate HD Tee - 4 Colors" ||
                  product.product?.name === "Sports CC T-Shirt" ||
                  product.product?.name === "TGS Uni CC Slate Tee - 4 Colors"
                ) {
                  const house = student.house;
                  if (house === "Dragons") {
                    productName = productName.replace("4 Colors", "Red");
                  }
                  if (house === "Pegasus") {
                    productName = productName.replace("4 Colors", "Blue");
                  }
                  if (house === "Sphinx") {
                    productName = productName.replace("4 Colors", "Yellow");
                  }
                  if (house === "Griffins") {
                    productName = productName.replace("4 Colors", "Green");
                  }
                }

                productRows.push({
                  name:
                    (product.product?.display_name
                      ? `${product.product.display_name} (${productName || product.product.name})`
                      : productName || product.product?.name) ||
                    item.bundle?.name ||
                    '',
                  size: product.size || '-',
                  quantity: product.totalQuantity,
                });
              }
            });
          } else if (item.bundle && item.bundle.bundleProducts) {
            // Fetch all products and sizes at once
            const products = await getProductsByIds(allProductIds);
            const sizes = await getSizesInBulk(studentProductMap);
            item.bundle.bundleProducts.forEach((product) => {
              const productObj = products[product.productId] || {};
              const size =
                student.id && sizes[student.id]
                  ? sizes[student.id][product.productId]?.size || ''
                  : '';

              productRows.push({
                name:
                  productObj.name ||
                  product.productName ||
                  item.bundle?.name ||
                  '',
                size: size || '-',
                quantity: item.quantity || product.quantity || 1,
              });
            });
          } else {
            productRows.push({
              name: item.bundle?.name || 'Single Product',
              size: '-',
              quantity: item.quantity || 1,
            });
          }
        }

        // Create rows HTML for this student's combined items
        productRows.forEach(product => {
          productCount = productCount + product.quantity;
          productRowsHtml += `
            <tr style="border-bottom: 1px solid #eee;">
              <td style="border: 1px solid black;padding: 5px; text-align: left;">${product.name}</td>
              <td style="border: 1px solid black;padding: 5px; text-align: center;">${product.size}</td>
              <td style="border: 1px solid black;padding: 5px; text-align: center;">${product.quantity}</td>
              <td style="border: 1px solid black;padding: 5px; text-align: center;"></td>
            </tr>
          `;
        });

        // Generate QR code data URL locally
        const qrDataUrl = await QRCode.toDataURL(`${student.usid || ''}`, {
          width: 150,
          margin: 1,
          errorCorrectionLevel: 'H'
        });

        // Set the full HTML template
        tempDiv.innerHTML = `
         <style>
            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }

            td {
              border: 1px solid #000;
              padding: 5px;
              vertical-align: top;
            }

            .address {
              height: 100px;
              font-size: 14px;
              line-height: 1.5;
            }

            .qr {
              display: flex;
              justify-content: center;   /* horizontal center */
              align-items: center;       /* vertical center */
              text-align: center;
            }

            .qr img {
              width: 200px;
              height: 200px;
              text-align: center;
              vertical-align: middle;
            }
          </style>
            <div style="padding: 20px; font-family: Arial, sans-serif; font-size: 16px; color: #333;">

              <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
    
                <!-- Row 1 -->
                <tr>
                  <td colspan="2" style="width: 60%; vertical-align: top; border-right: none">
                    <strong>Delivery Address :</strong><br>
                    <strong>${order.parent?.parentName || ''},</strong><br/>
                    ${order.parent?.pincode
            ? (order.deliveryAddress || '')
              .replace(order.parent?.pincode + ".", '')   // remove all existing pincodes like 500100.
              .replace(order.parent?.pincode, '')         // fix double commas
              .replace(/,\s*$/, '')           // remove trailing comma
              .trim() + " " + order.parent?.pincode
            : (order.deliveryAddress || '')
          }, ${order.parent?.phoneNumber || ''}
                  </td>
                  <td style="width: 15%; border-left: none;"></td>
                  <!-- QR -->
                  <td rowspan="3" 
                      style="text-align: center; vertical-align: middle;">
                      <img 
                        id="qr-code-${studentIndex}" 
                        src="${qrDataUrl}" 
                        style="width: 150px; height: 150px; display: block; margin: auto;" 
                      />
                  </td>
                </tr>

                <!-- Row 2 -->
                <tr>
                  <td colspan="3" >
                    <strong>Student Name :</strong> ${student.studentName || ''} <strong>USID : </strong>${student.usid || ''}
                  </td>
                </tr>

                <!-- Row 3 -->
                <tr>
                  <td>
                    <strong>Grade & Sec:</strong> ${student.class || ''}${student.section ? ' - ' + student.section : ''}
                  </td>
                  <td>
                    <strong>House:</strong> ${student.house || ''}
                  </td>
                  <td>
                    <strong>Gender:</strong> ${student.gender || ''}
                  </td>
                </tr>

              </table>
              
              <table style="width: 100%; border: 1px solid black;">
                <thead>
                  <tr style="border-bottom: 1px solid black; background-color: #f9f9f9;">
                    <th style="padding: 5px 5px; text-align: left; width: 75%;">Product</th>
                    <th style="padding: 5px 5px; text-align: left; width: 8%;">Size</th>
                    <th style="padding: 5px 5px; text-align: left; width: 7%;">Qnty</th>
                    <th style="padding: 5px 5px; text-align: left; width: 10%;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  ${productRowsHtml}
                  <tr style="border-bottom: 1px solid #eee;">
                    <td style="border: 1px solid black;padding: 5px; text-align: center;"><strong>Total (Items)</strong></td>
                    <td style="border: 1px solid black;padding: 5px; text-align: center;"></td>
                    <td style="border: 1px solid black;padding: 5px; text-align: center;"><strong>${productCount}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          `;

        try {
          // Wait for QR code image to load
          const qrImg = tempDiv.querySelector(`#qr-code-${studentIndex}`);
          if (qrImg) {
            await new Promise((resolve) => {
              if (qrImg.complete) resolve();
              else {
                qrImg.onload = resolve;
                qrImg.onerror = resolve;
              }
            });
          }

          // Convert HTML to canvas
          const canvas = await html2canvas(tempDiv, {
            scale: 2,
            logging: false,
            useCORS: true,
            allowTaint: true
          });

          // Add canvas to the PDF on the current page
          const imgData = canvas.toDataURL('image/png');
          const imgProps = pdf.getImageProperties(imgData);
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

          // If we are on the bottom half and the item won't fit, start a new page
          if (currentY > 0 && (currentY + pdfHeight > pageHeight)) {
            pdf.addPage();
            currentY = 0;
          }

          pdf.addImage(imgData, 'PNG', 0, currentY, pdfWidth, pdfHeight);

          if (studentIndex < studentEntries.length - 1) {
            // Decide where the next item goes
            if (currentY === 0 && pdfHeight <= halfPageHeight) {
              // Current item is on top and is small. Next one can try the bottom.
              currentY = halfPageHeight;
              // Add separator
              pdf.setLineDash([2, 2], 0);
              pdf.line(0, halfPageHeight, pdfWidth, halfPageHeight);
              pdf.setLineDash([], 0);
            } else {
              // Current item was on bottom, or it was too big for top half.
              // Next item MUST be on a new page.
              pdf.addPage();
              currentY = 0;
            }
          }
        } finally {
          // Clean up the temporary div
          document.body.removeChild(tempDiv);
        }
      }

      // Save the multi-page PDF
      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfPreview({
        show: true,
        url: pdfUrl,
        blob: pdfBlob,
        fileName: `Order_Slip_${order.id}.pdf`
      });

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate order slip PDF");
    } finally {
      setLoading(false);
    }
  };

  const printAllOrderSlips = async (orderIdsOrOrder, isAll = false, customExportType = null) => {
    setLoading(true);
    try {
      const exportTypeToUse = customExportType || slipExportType || "shoes";
      let params = {};

      if (isAll) {
          params = {
            search: searchTerm,
            startDate,
            endDate,
            status: statusFilter,
            paymentStatus: paymentstatusFilter,
            settlementStatus,
            isVendor,
            sortKey,
            sortOrder,
            academic_year: currentYear,
            orderType,
            all: "all",
            exportType: exportTypeToUse,
          };
      } else {
        let orderIds = [];
        if (Array.isArray(orderIdsOrOrder)) {
          if (orderIdsOrOrder.length === 0) {
            toast.warning("Please select at least one order");
            setLoading(false);
            return;
          }
          orderIds = orderIdsOrOrder;
        } else {
          orderIds = [orderIdsOrOrder.id];
        }
        params = { orderIds, type: orderType, exportType: exportTypeToUse };
      }

      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(
          ([_, value]) => value !== undefined && value !== null && value !== ''
        )
      );

      const blob = await printAllOrderSlipsApi(filteredParams);
      
      if (blob && blob.size > 0) {
        const pdfUrl = URL.createObjectURL(blob);
        setPdfPreview({
          show: true,
          url: pdfUrl,
          blob: blob,
          fileName: `All_Order_Slips.pdf`
        });
        toast.success("Order slips generated successfully");
      } else {
        toast.error("Failed to generate order slips");
      }
    } catch (error) {
      console.error("Error generating slips:", error);
      toast.error("Failed to generate order slips");
    } finally {
      setLoading(false);
    }
  };

  const printDetailedOrderSlips = async (orderIdsOrOrder, isAll = false) => {
    setLoading(true);

    try {
      let params = {};
      let fileName = "Order_Slips.pdf";
      
      if (isAll) {
        params = {
          all: "all",
          page: currentPage,
          limit: itemsPerPage,
          search: searchTerm,
          startDate: startDate,
          endDate: endDate,
          status: statusFilter,
          transactionStatus: paymentstatusFilter,
          settlementStatus: settlementStatus,
          isVendor: isVendor,
          sortKey: sortKey,
          sortOrder: sortOrder,
          academic_year: currentYear,
          type: orderType
        };
        fileName = "All_Filtered_Order_Slips.pdf";
      } else {
        let orderIds = [];
        if (Array.isArray(orderIdsOrOrder)) {
          if (orderIdsOrOrder.length === 0) {
            toast.warning("Please select at least one order");
            setLoading(false);
            return;
          }
          orderIds = orderIdsOrOrder;
          fileName = orderIds.length === 1 ? `Order_Slip_${orderIds[0]}.pdf` : `Selected_Order_Slips.pdf`;
        } else {
          orderIds = [orderIdsOrOrder.id];
          fileName = `Order_Slip_${orderIdsOrOrder.id}.pdf`;
        }
        params = { orderIds, type: orderType };
      }

      const filteredParams = Object.fromEntries(
          Object.entries(params).filter(
            ([_, value]) => value !== undefined && value !== null && value !== ''
          )
        );

      const response = await generateOrderSlipsPdf(filteredParams);

      if (!response || response instanceof Error) {
        throw new Error(response?.message || "Failed to generate PDF");
      }

      console.log('Received PDF response, size:', response.size || response.length);

      // response should already be a Blob because of responseType: 'blob'
      const pdfBlob = response instanceof Blob ? response : new Blob([response], { type: 'application/pdf' });

      if (pdfBlob.size < 100) {
        console.warn('PDF blob is suspiciously small:', pdfBlob.size);
      }

      const pdfUrl = URL.createObjectURL(pdfBlob);

      setPdfPreview({
        show: true,
        url: pdfUrl,
        blob: pdfBlob,
        fileName: fileName
      });

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error(error.message || "Failed to generate order slips");
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadPdf = () => {
    if (pdfPreview.blob && pdfPreview.fileName) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(pdfPreview.blob);
      link.download = pdfPreview.fileName;
      link.click();
      setPdfPreview({ ...pdfPreview, show: false });
    }
  };

  // Export Orders to Excel (Simplified summary version via Backend)
  const exportOrdersToExcel = async () => {
    setLoading(true);

    try {
      const blob = await exportOrdersToExcelApi(
        searchTerm,
        startDate,
        endDate,
        statusFilter,
        paymentstatusFilter,
        settlementStatus,
        isVendor,
        sortKey,
        sortOrder,
        currentYear,
        orderType
      );

      if (blob && (blob.size > 0 || blob.length > 0)) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "Orders_Export.csv");
        document.body.appendChild(link);
        link.click();

        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);

        toast.success("Orders exported successfully");
      } else {
        toast.warning("No data found to export");
      }
    } catch (error) {
      console.error("Error exporting orders:", error);
      toast.error("Failed to export orders");
    } finally {
      setLoading(false);
    }
  };

  // Handle file upload for bulk updates
  const fileInputRef = useRef(null);
  const orderSlipInputRef = useRef(null);

  const handleOrderSlipFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Get data as array of arrays
        const json = utils.sheet_to_json(worksheet, { header: 1 });

        if (json.length === 0) {
          toast.error("The sheet is empty");
          setLoading(false);
          return;
        }

        let orderIds = [];
        const orderIdRegex = /^O[A-Z0-9]+$/;

        // Try to find headers
        const headers = json[0];
        let orderIdIndex = -1;
        if (headers) {
          orderIdIndex = headers.findIndex(h => 
            h && (h.toString().toLowerCase().includes('order id') || h.toString().toLowerCase().includes('order_id'))
          );
        }

        if (orderIdIndex !== -1) {
          for (let i = 1; i < json.length; i++) {
            const val = json[i][orderIdIndex];
            if (val) orderIds.push(val.toString().trim());
          }
        } else {
          // Look for any cell matching the pattern
          json.forEach(row => {
            if (Array.isArray(row)) {
              row.forEach(cell => {
                if (cell && orderIdRegex.test(cell.toString().trim())) {
                  orderIds.push(cell.toString().trim());
                }
              });
            }
          });
        }

        // Deduplicate
        orderIds = [...new Set(orderIds)];

        if (orderIds.length === 0) {
          toast.error("No Order IDs found in the sheet. Ensure IDs start with 'O' and contain only alphanumeric characters.");
          setLoading(false);
          return;
        }

        toast.info(`Found ${orderIds.length} Order IDs. Generating slips...`);
        await printAllOrderSlips(orderIds);
      } catch (error) {
        console.error("Error processing file:", error);
        toast.error("Failed to process the Excel/CSV file: " + error.message);
      } finally {
        setLoading(false);
        if (orderSlipInputRef.current) orderSlipInputRef.current.value = "";
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['text/csv', 'application/vnd.ms-excel'];
    const isCsvExtension = file.name.toLowerCase().endsWith('.csv');

    if (!allowedTypes.includes(file.type) && !isCsvExtension) {
      toast.error(`'Only CSV files are allowed. Please upload a .csv file.`);
      setLoading(false);
      return;
    }

    setLoading(true);

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const csv = e.target.result;
        const lines = csv.split('\n');
        const headers = lines[0].split(',').map(header => header.trim());

        // Check if required columns exist
        const isStoreOrSuper = isStoreAdmin || isSuperadmin;
        const requiredColumns = isStoreOrSuper ? ['Order ID'] : ['Order ID', 'Application Code', ...(isVendor ? ['Delivery Status', 'Tracking ID'] : ['Transaction Status', 'Settlement Status'])];
        const missingColumns = requiredColumns.filter(col => !headers.includes(col));

        if (missingColumns.length > 0) {
          toast.error(`Missing required columns: ${missingColumns.join(', ')}`);
          setLoading(false);
          return;
        }

        // Parse data
        const result = [];
        const invalidRows = [];

        for (let i = 1; i < lines.length; i++) {
          if (lines[i].trim() === '') continue;

          const values = lines[i].split(',').map(value => value.trim());
          if (values.length !== headers.length) continue;

          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = values[index];
          });

          // Validate Transaction Status and Settlement Status (only for non-store/superadmin immediate process)
          if (!isStoreOrSuper) {
            const validTransactionStatus = ['PAID', 'FAILED'];
            const validSettlementStatus = ['SETTLED', 'PENDING', 'FAILED'];
            const validDeliveryStatus = ['IN_PROGRESS', 'ARRIVED_AT_WAREHOUSE','HOLD_AT_WAREHOUSE', 'PACKED', 'SHIPPED', 'OUT_FOR_DELIVERY', 'DELIVERED', 'PARTIALLY_DELIVERED'];

            const rowNum = i + 1; // Adding 1 to account for 0-indexing and header row
            let isValid = true;

            if (isVendor) {
              if (!validDeliveryStatus.includes(obj['Delivery Status'])) {
                invalidRows.push(`Row ${rowNum}: Invalid Delivery Status "${obj['Delivery Status']}"`);
                isValid = false;
              }
            } else {
              if (!validTransactionStatus.includes(obj['Transaction Status'])) {
                invalidRows.push(`Row ${rowNum}: Invalid Transaction Status "${obj['Transaction Status']}"`);
                isValid = false;
              }

              if (!validSettlementStatus.includes(obj['Settlement Status'])) {
                invalidRows.push(`Row ${rowNum}: Invalid Settlement Status "${obj['Settlement Status']}"`);
                isValid = false;
              }
            }

            if (isValid) {
              result.push(obj);
            }
          } else {
            // For Store/Superadmin, we just need the Order ID
            if (obj['Order ID']) {
              result.push(obj);
            }
          }
        }

        if (invalidRows.length > 0) {
          // Show first 5 errors with a count of total errors
          const errorMessage = invalidRows.slice(0, 5);
          if (invalidRows.length > 5) {
            errorMessage.push(`\n...and ${invalidRows.length - 5} more errors`);
          }

          setUploadStatus({
            show: true,
            success: 0,
            failed: invalidRows.length,
            errors: errorMessage
          });
          setLoading(false);
          return;
        }

        if (result.length === 0) {
          toast.error("No valid data found in the file");
          setLoading(false);
          return;
        }

        const hasDeliveryStatus = headers.includes('Delivery Status');
        if (isStoreOrSuper && !hasDeliveryStatus) {
          setCsvData(result);
          setCsvHeaders(headers);
          
          // Fetch preview details
          setLoadingPreview(true);
          setShowCsvPreviewModal(true);
          setLoading(false);

          try {
            const orderIds = result.map(row => row['Order ID']);
            const details = await fetchBulkPreview(orderIds);
            setPreviewDetails(details || []);
          } catch (error) {
            console.error("Error fetching preview details:", error);
            toast.error("Failed to fetch order details for preview");
          } finally {
            setLoadingPreview(false);
          }
          return;
        }

        // Process the data immediately for other roles
        try {
          // Check which columns exist in the CSV headers
          const hasOrderId = headers.includes('Order ID');
          const hasTransactionStatus = headers.includes('Transaction Status');
          const hasSettlementStatus = headers.includes('Settlement Status');
          const hasApplicationCode = headers.includes('Application Code');
          const hasTrackingId = headers.includes('Tracking ID');

          // Transform the data to match the API request format
          const transformedData = {
            transactions: result.map(item => {
              // Create transaction object with only the properties for columns that exist in the CSV
              const transaction = {};

              if (hasOrderId) {
                transaction.orderId = item['Order ID'];
              }

              if (hasTransactionStatus || hasDeliveryStatus) {
                transaction.status = (isVendor || isStoreAdmin) ? (item['Delivery Status'] || item['Transaction Status']) : item['Transaction Status'];
              }

              if (hasSettlementStatus) {
                transaction.settlement_status = item['Settlement Status'];
              }

              if (hasApplicationCode) {
                transaction.application_code = item['Application Code'];
              }

              if (hasTrackingId) {
                transaction.trackingId = item['Tracking ID'];
              }

              return transaction;
            })
          };

          // Call the API
          const response = (isVendor || isStoreAdmin) ? await bulkUpdateDeliveryStatus(transformedData) : await bulkUpdateTransactionStatus(transformedData);

          // Handle response according to the expected format
          setUploadStatus({
            show: true,
            success: response.successCount || 0,
            failed: response.failedCount || 0,
            errors: [response.message]
          });

          // Refresh orders list
          const ordersResponse = await fetchAllOrders(1, 10);
          let ordersArray = Array.isArray(ordersResponse) ? ordersResponse : [];
          if (isVendor) {
            ordersArray = ordersArray.filter(order => order.transactionStatus === "PAID");
          }
          setOrders(ordersArray);
        } catch (error) {
          console.error("Error updating orders:", error);
          setUploadStatus({
            show: true,
            success: 0,
            failed: result.length,
            errors: ["Unknown error occurred during bulk update"]
          });
        }
      } catch (error) {
        console.error("Error parsing CSV:", error);
        setUploadStatus({
          show: true,
          success: 0,
          failed: 1,
          errors: ["Failed to parse CSV file: " + (error.message || "Unknown error")]
        });
      } finally {
        setLoading(false);
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    };

    reader.readAsText(file);
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const statusSequence = [
    { key: "IN_PROGRESS", order: 1, value: "IN_PROGRESS" },
    { key: "ARRIVED_AT_WAREHOUSE", order: 2, value: "ARRIVED_AT_WAREHOUSE" },
    { key: "HOLD_AT_WAREHOUSE", order: 3, value: "HOLD_AT_WAREHOUSE" },
    { key: "PACKED", order: 4, value: "PACKED" },
    { key: "SHIPPED", order: 5, value: "SHIPPED" },
    { key: "OUT_FOR_DELIVERY", order: 6, value: "OUT_FOR_DELIVERY" },
    { key: "DELIVERY_IN_PROGRESS", order: 7, value: "DELIVERY_IN_PROGRESS" },
    { key: "ATTEMPTED", order: 8, value: "ATTEMPTED" },
    { key: "HELDUP", order: 9, value: "HELDUP" },
    { key: "RTO", order: 10, value: "RTO" },
    { key: "PARTIALLY_DELIVERED", order: 11, value: "PARTIALLY_DELIVERED" },
    { key: "DELIVERED", order: 12, value: "DELIVERED" },
  ];

  const LabelSelectionModal = ({ show, onHide, onSelect, options }) => {
    const [selectedLabel, setSelectedLabel] = useState(options[0].value);

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Label Format</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Choose a format for the shipping label:</Form.Label>
            <Form.Select
              value={selectedLabel}
              onChange={(e) => setSelectedLabel(e.target.value)}
            >
              {options.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button variant="primary" onClick={() => onSelect(selectedLabel)}>Print</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <style>{`
        .cursor-pointer { cursor: pointer; }
        .table-responsive::-webkit-scrollbar { height: 8px; }
        .table-responsive::-webkit-scrollbar-thumb { background: #dee2e6; border-radius: 4px; }
        .filter-card { transition: all 0.3s ease; }
        .action-btn { transition: transform 0.2s; white-space: nowrap; }
        .action-btn:hover { transform: translateY(-1px); }
        .table th { white-space: nowrap; font-size: 0.85rem; text-transform: uppercase; letter-spacing: 0.5px; }
        .table td { font-size: 0.9rem; }
        .pagination-container { border-top: 1px solid #dee2e6; padding-top: 1.5rem; }
      `}</style>
      {loading && <FullPageSpinner loading={loading} />}
      <div className="bg-mid page-shadow min-vh-100 py-4">
        <div className="container-fluid px-lg-4">
          <div className="card shadow-sm border-0 rounded-3">
            <div className="card-header bg-white border-bottom py-3 px-4">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <h4 className="mb-0 text-primary fw-bold d-flex align-items-center">
                  <i className="bi bi-cart-check-fill me-2"></i>Order Management
                </h4>
                <div className="d-flex align-items-center gap-2">
                  <span className="badge bg-primary rounded-pill px-3 py-2">Total: {totalItems}</span>
                </div>
              </div>
            </div>
            
            <div className="card-body p-4">
              {user?.role === ROLES.SUPER_ADMIN && orderStats && (
                <div className="row g-3 mb-4">
                  {/* Delivery Status Stats */}
                  <div className="col-12">
                    <h6 className="text-uppercase text-muted fw-bold mb-3 small">Delivery Status Statistics</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {orderStats.statusStats?.length > 0 ? (
                        orderStats.statusStats.map((stat) => (
                          <div key={stat.status} className="card shadow-sm border-0 bg-light p-2 flex-grow-1" style={{ minWidth: '150px' }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="small text-muted text-capitalize">{stat.status?.replace(/_/g, ' ') || 'Unknown'}</span>
                              <span className="badge bg-primary rounded-pill">{stat.count}</span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted small">No delivery stats available</div>
                      )}
                    </div>
                  </div>                  
                </div>
              )}

              {/* Filters & Actions Section */}
              <div className="bg-white rounded-3 p-4 mb-4 border shadow-sm filter-card">
                <div className="row g-3 align-items-end mb-4">
                  <div className="col-12 col-md-6 col-lg-3">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Search Orders
                    </label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-white border-end-0">
                        <i className="bi bi-search text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="USID, Name, Order ID..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  
                  <div className="col-12 col-md-6 col-lg-3">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Date Range
                    </label>
                    <div className="input-group input-group-sm">
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                      <span className="input-group-text bg-light border-0 px-2 small">to</span>
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-6 col-md-4 col-lg-2">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Delivery
                    </label>
                    <Form.Select
                      size="sm"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option value="">All Status</option>
                      {orderStatusList.map((status) => (
                        <option key={status.name} value={status.name}>
                          {status.displayName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  {filterByPayment && (
                    <>
                      <div className="col-6 col-md-4 col-lg-2">
                        <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                          Settlement
                        </label>
                        <Form.Select
                          size="sm"
                          value={settlementStatus}
                          onChange={(e) => setSettlementStatus(e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="SETTLED">Settled</option>
                          <option value="PENDING">Pending</option>
                          <option value="FAILED">Failed</option>
                        </Form.Select>
                      </div>
                      <div className="col-6 col-md-4 col-lg-2">
                        <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                          Payment
                        </label>
                        <Form.Select
                          size="sm"
                          value={paymentstatusFilter}
                          onChange={(e) => setPaymentstatusFilter(e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="FAILED">Failed</option>
                          <option value="PAID">Paid</option>
                        </Form.Select>
                      </div>
                    </>
                  )}

                  <div className="col-6 col-md-4 col-lg-2">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Academic Year
                    </label>
                    <Form.Select
                      size="sm"
                      value={currentYear}
                      onChange={(e) => setCurrentYear(e.target.value)}
                    >
                      {academicYears.map((year) => (
                        <option key={year.year} value={year.year}>
                          {year.year}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  {(isAdmin || isSuperadmin || isStoreAdmin) && (
                    <div className="col-6 col-md-4 col-lg-2">
                      <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                        Order Type
                      </label>
                      <Form.Select
                        size="sm"
                        value={orderType}
                        onChange={(e) => setOrderType(e.target.value)}
                      >
                        <option value="">All Types</option>
                        <option value={ORDER_TYPES.ORIGINAL}>Original Orders</option>
                        <option value={ORDER_TYPES.FAKE}>Adjusted Orders</option>
                      </Form.Select>
                    </div>
                  )}

                  <div className="col-6 col-md-4 col-lg-2">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Bundle / Product
                    </label>
                    <Form.Select
                      size="sm"
                      value={itemCategoryFilter}
                      onChange={(e) => setItemCategoryFilter(e.target.value)}
                    >
                      <option value="">All Items</option>
                      <option value="bundle">Bundles Only</option>
                      <option value="single">Single Products Only</option>
                    </Form.Select>
                  </div>
                  {(isAdmin || isSuperadmin || isStoreAdmin) && (

                  <div className="col-6 col-md-4 col-lg-2">
                    <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                      Slip Type
                    </label>
                    <Form.Select
                      size="sm"
                      value={slipExportType}
                      onChange={(e) => setSlipExportType(e.target.value)}
                    >
                      <option value="shoes">Shoes Only</option>
                      <option value="non-shoes">Non-Shoes Only</option>
                      <option value="all">All Products</option>
                    </Form.Select>
                  </div>
                  )}
                  
                  <div className="col-12 col-md-4 col-lg-3 d-flex gap-2">
                    <Button
                      variant="primary"
                      size="sm"
                      className="flex-grow-1 fw-bold shadow-sm"
                      onClick={getOrders}
                    >
                      <i className="bi bi-arrow-clockwise me-1"></i> Refresh
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="flex-grow-1 fw-bold shadow-sm"
                      onClick={handleReset}
                    >
                      <i className="bi bi-x-circle me-1"></i> Reset
                    </Button>
                  </div>
                </div>
              <div className="pt-3 border-top">
                  <input
                    type="file"
                    accept=".csv"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                  />

                  <div className="row g-2 justify-content-center justify-content-md-end">
                    {selectedOrders.length > 0 && (
                      <div className="col-6 col-md-auto">
                        <Button
                          variant="outline-secondary"
                          className="action-btn responsive-btn w-100 fw-bold"
                          onClick={() => setSelectedOrders([])}
                        >
                          <i className="bi bi-dash-circle me-1"></i>
                          Clear Selection ({selectedOrders.length})
                        </Button>
                      </div>
                    )}

                    {canUpdateStatus && selectedOrders.length > 0 && (
                      <div className="col-6 col-md-auto">
                        <Button
                          variant="warning"
                          className="action-btn responsive-btn w-100 fw-bold"
                          onClick={() => setShowBulkModal(true)}
                        >
                          <i className="bi bi-pencil-square me-1"></i>
                          Bulk Update ({selectedOrders.length})
                        </Button>
                      </div>
                    )}

                    {canPrintOrderSlips && (
                      <div className="col-6 col-md-auto">
                        <Button
                          variant="outline-primary"
                          className="action-btn responsive-btn w-100 fw-bold"
                          onClick={() => printDetailedOrderSlips(selectedOrders, selectedOrders.length > 0 ? false : true)}
                        >
                          <i className="bi bi-file-earmark-pdf me-1"></i>
                          Print Payment Slip {selectedOrders.length > 0 && `(${selectedOrders.length})`}
                        </Button>
                      </div>
                    )}

                    {canBulkUpload && 
                    <div className="col-6 col-md-auto">
                      <Button
                        variant="outline-primary"
                        className="action-btn responsive-btn w-100"
                        onClick={triggerFileInput}
                      >
                        <i className="bi bi-upload me-1"></i>
                        Bulk Upload
                      </Button>
                    </div>
                    }
                    {canPrintAllSlips && (
                    <div className="col-6 col-md-auto">
                      <Button
                        variant="outline-danger"
                        className="action-btn responsive-btn w-100"
                        onClick={() => printAllOrderSlips(selectedOrders, selectedOrders.length > 0 ? false : true)}
                      >
                        <i className="bi bi-printer me-1"></i>
                        Print Order Slips {selectedOrders.length > 0 && `(${selectedOrders.length})`}
                      </Button>
                    </div>
                    )}
                    {canPrintAllSlips && (
                    <div className="col-6 col-md-auto">
                      <input
                        type="file"
                        accept=".xlsx, .xls, .csv"
                        ref={orderSlipInputRef}
                        onChange={handleOrderSlipFileUpload}
                        style={{ display: "none" }}
                      />
                      <Button
                        variant="outline-warning"
                        className="action-btn responsive-btn w-100 fw-bold"
                        onClick={() => orderSlipInputRef.current.click()}
                      >
                        <i className="bi bi-file-earmark-excel me-1"></i>
                        Print from Excel
                      </Button>
                    </div>
                    )}
                    {canExportOrders && (
                    <><div className="col-6 col-md-auto">
                        <Button
                          variant="outline-info"
                          className="action-btn responsive-btn w-100"
                          onClick={exportOrdersToExcel}
                        >
                          <i className="bi bi-file-earmark-spreadsheet me-1"></i>
                          Export Orders
                        </Button>
                      </div><div className="col-6 col-md-auto">
                          <Button
                            variant="outline-success"
                            className="action-btn responsive-btn w-100"
                            onClick={() => setShowExportModal(true)}
                          >
                            <i className="bi bi-file-earmark-csv me-1"></i>
                            Export CSV
                          </Button>
                        </div></>
                    )}
                  </div>
                </div>
              </div>

              {uploadStatus.show && (
                <div className={`alert ${uploadStatus.failed > 0 ? 'alert-warning' : 'alert-success'} alert-dismissible fade show rounded-3 shadow-sm mb-4`} role="alert">
                  <div className="d-flex align-items-center mb-2">
                    <i className={`bi ${uploadStatus.failed > 0 ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'} me-2 fs-5`}></i>
                    <h5 className="mb-0">Bulk Update Results</h5>
                  </div>
                  <div className="row g-2">
                    <div className="col-auto">
                      <span className="badge bg-success">Success: {uploadStatus.success}</span>
                    </div>
                    {uploadStatus.failed > 0 && (
                      <div className="col-auto">
                        <span className="badge bg-danger">Failed: {uploadStatus.failed}</span>
                      </div>
                    )}
                  </div>
                  {uploadStatus.failed > 0 && (
                    <div className="mt-3 p-2 bg-white rounded border" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                      <p className="small fw-bold text-muted mb-1">Error Logs:</p>
                      <ul className="list-unstyled small mb-0">
                        {uploadStatus.errors.map((error, index) => (
                          <li key={index} className="text-danger mb-1">• {error}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <button type="button" className="btn-close" onClick={() => setUploadStatus({ ...uploadStatus, show: false })} aria-label="Close"></button>
                </div>
              )}

              {/* Table Section */}
              <div className="table-responsive rounded-3 border shadow-sm bg-white">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      
                      <th className="text-center px-3" style={{ width: '40px' }}>
                        {(canPrintOrderSlips || canPrintAllSlips) &&
                        <Form.Check
                          type="checkbox"
                          checked={
                            selectableOrders.length > 0 &&
                            selectableOrders.every(o => selectedOrders.includes(o.id))
                          }
                          onChange={toggleSelectAll}
                        />}
                      </th>
                      
                      <th className="cursor-pointer" onClick={() => handleSort("order.id")}>Order ID {renderSortArrow("order.id")}</th>
                      <th className="cursor-pointer" >Payment ID</th>
                      <th className="cursor-pointer" onClick={() => handleSort("parent.parentName")}>Parent Name {renderSortArrow("parent.parentName")}</th>
                      <th>USID</th>
                      <th>Student Names</th>
                      <th>House</th>
                      <th className="cursor-pointer text-end" onClick={() => handleSort("order.totalPrice")}>Total Price {renderSortArrow("order.totalPrice")}</th>
                      <th className="cursor-pointer" onClick={() => handleSort(isVendor ? "status" : "order.transactionStatus")}>
                        {isVendor ? "Delivery" : "Transaction"} {renderSortArrow(isVendor ? "status" : "order.transactionStatus")}
                      </th>
                      {!isVendor && <th className="cursor-pointer" onClick={() => handleSort("status")}>Delivery {renderSortArrow("status")}</th>}
                      <th className="cursor-pointer" onClick={() => handleSort("order.createdAt")}>Date {renderSortArrow("order.createdAt")}</th>
                      {user?.role === ROLES.SUPER_ADMIN &&
                        <th className="cursor-pointer" onClick={() => handleSort("order.updatedAt")}>updatedAt {renderSortArrow("order.updatedAt")}</th>
                      }
                      <th>Mode</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.length > 0 ? (
                      orders.map((order) => (
                        <tr key={order.id}>
                          
                          <td className="text-center px-3">
                             {(canPrintOrderSlips || canPrintAllSlips) &&
                              <Form.Check
                                  type="checkbox"
                                  checked={selectedOrders.includes(order.id)}
                                  disabled={order.status === "DELIVERED" || order.transactionStatus === "PENDING"}
                                  onChange={() => handleSelectOrder(order.id)}
                                />
                              }
                          </td>
                          <td className="fw-bold text-dark">
                            <div>{order.orderId}</div>
                            {order.customerCode && (
                              <span
                                className="badge bg-secondary font-monospace mt-1"
                                style={{ fontSize: "10px", fontWeight: "normal" }}
                                title={`DTDC Customer Code: ${order.customerCode}`}
                              >
                                {order.customerCode}
                              </span>
                            )}
                          </td>
                          <td className="fw-bold text-dark">{order.txnID}</td>
                          <td>
                            <div className="fw-semibold text-truncate" style={{ maxWidth: '150px' }} title={order.parent?.parentName}>
                              {order.parent?.parentName}
                            </div>
                          </td>
                          <td className="small">{order.studentUSIDs}</td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '200px' }} title={order.studentNames}>
                              {order.studentNames}
                            </div>
                          </td>
                          <td className="small">{order.studentHouses}</td>
                          <td className="text-end fw-bold">₹{order.totalPrice}</td>
                          <td>
                            <span className={`badge rounded-pill ${order.transactionStatus === 'PAID' ? 'bg-success' : 'bg-warning text-dark'} text-capitalize`}>
                              {isVendor ? order.status : order.transactionStatus}
                            </span>
                          </td>
                          {!isVendor && (
                            <td>
                              <span className="badge bg-info text-capitalize">{order.status}</span>
                              {order.note && <span><br></br>note: {order.note}</span>}
                            </td>
                          )}
                          <td className="small">{formatDateTime(order.createdAt)}</td>
                          {user?.role === ROLES.SUPER_ADMIN &&
                              <td className="small">{formatDateTime(order.updatedAt)}</td>
                          }
                          <td className="small text-capitalize">
                            {order.shippingMethod === "home"
                            ? `Home${order.deliveryCharges > 0 ? ` (₹${order.deliveryCharges})` : ""}`
                            : order.shippingMethod || "-"}
                          </td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-1">
                              {canViewOrderDetails && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={() => onView(order)}
                                  title="View Details"
                                  style={{ width: '30px', height: '30px', padding: 0 }}
                                >
                                  <i className="bi bi-eye"></i>
                                </Button>
                              )}
                              {canEditOrder && (
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={() => onManageDelivery(order)}
                                  title="Manage Delivery"
                                  style={{ width: '30px', height: '30px', padding: 0 }}
                                >
                                  <i className="bi bi-truck"></i>
                                </Button>
                              )}
                              {canPrintOrderSlips && (
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={() => printOrderSlip(order)}
                                  title="Print Slip"
                                  style={{ width: '30px', height: '30px', padding: 0 }}
                                >
                                  <i className="bi bi-printer"></i>
                                </Button>
                              )}
                              {isSuperadmin && (
                                <Button
                                  variant="outline-warning"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={() => handleOpenAddressModal(order)}
                                  title="Update Address (Superadmin)"
                                  style={{ width: '30px', height: '30px', padding: 0 }}
                                >
                                  <i className="bi bi-geo-alt"></i>
                                </Button>
                              )}
                              {canPrintAllSlips && order.trackingId && order?.status !== "CANCELLED" && order?.status !== "DELIVERED" && order?.status !=='OUT_FOR_DELIVERY' && (
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  className="rounded-circle"
                                  onClick={() => handlePrintLabelClick(order.id)}
                                  title="Print Label"
                                  style={{ width: '30px', height: '30px', padding: 0 }}
                                >
                                  <i className="bi bi-tag"></i>
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="13" className="text-center py-5 text-muted">
                          <i className="bi bi-inbox fs-1 d-block mb-2"></i>
                          No orders found matching your criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Section */}
              <div className="pagination-container d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
                <div className="d-flex align-items-center gap-3 order-2 order-md-1">
                  <div className="d-flex align-items-center bg-white border rounded px-2 py-1 shadow-sm">
                    <span className="text-muted small me-2">Show</span>
                    <Form.Select
                      size="sm"
                      value={itemsPerPage}
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                      className="border-0 bg-transparent fw-bold"
                      style={{ width: 'auto', outline: 'none', boxShadow: 'none' }}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Form.Select>
                    <span className="text-muted small ms-2">entries</span>
                  </div>
                  <div className="text-muted small border-start ps-3 d-none d-sm-block">
                    Showing <span className="fw-bold text-dark">{(currentPage - 1) * itemsPerPage + 1}</span> to <span className="fw-bold text-dark">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of <span className="fw-bold text-dark">{totalItems}</span> records
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2 order-1 order-md-2">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 rounded-pill shadow-sm fw-bold"
                  >
                    <i className="bi bi-chevron-left"></i> Prev
                  </Button>
                  
                  <div className="bg-white px-3 py-1 rounded-pill border shadow-sm small fw-bold">
                    Page {currentPage} of {totalPages}
                  </div>

                  <Button
                    variant="outline-primary"
                    size="sm"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 rounded-pill shadow-sm fw-bold"
                  >
                    Next <i className="bi bi-chevron-right"></i>
                  </Button>
                </div>
              </div>

              {/* Order Details Modal */}
              <Modal size="lg" show={showModal} onHide={() => {
                setShowModal(false);
                setBarcode("");
                setApplicationCode("");
              }} centered backdrop="static">
                <Modal.Header closeButton className="bg-light">
                  <Modal.Title className="fw-bold text-primary">
                    <i className="bi bi-info-circle me-2"></i>Order Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                  {selectedOrder && !showDetailsModal && (
                    <div className="row g-4">
                      <div className="col-md-6 border-end">
                        <h6 className="text-uppercase text-muted fw-bold mb-3 small border-bottom pb-2">Primary Information</h6>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">Order ID:</span>
                          <span className="fw-bold">{selectedOrder.orderId}</span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">Total Price:</span>
                          <span className="fw-bold text-primary">₹{selectedOrder.totalPrice}</span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">Created At:</span>
                          <span className="fw-bold">{formatDateTime(selectedOrder.createdAt)}</span>
                        </div>
                        
                        <div className="d-flex justify-content-between align-items-center mt-4 mb-2 border-bottom pb-2">
                          <h6 className="text-uppercase text-muted fw-bold small mb-0">Delivery & Parent Details</h6>
                          {isSuperadmin && (
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="py-0 px-2"
                              style={{ fontSize: "11px" }}
                              onClick={() => {
                                setAddressOrder(selectedOrder);
                                setShowAddressModal(true);
                              }}
                            >
                              <i className="bi bi-pencil-square me-1"></i>Edit Address
                            </Button>
                          )}
                        </div>
                        <div className="mb-2">
                          <div className="fw-bold">{selectedOrder.parent?.parentName}</div>
                          <div className="text-muted small"><i className="bi bi-telephone me-1"></i>{selectedOrder.deliveryContact || selectedOrder.parent?.phoneNumber}</div>
                          <div className="text-muted small mt-1">
                            <i className="bi bi-geo-alt-fill me-1 text-danger"></i>
                            <strong>Address: </strong>
                            {selectedOrder.deliveryAddress || selectedOrder.parent?.address || "--"}
                          </div>
                          <div className="text-muted small mt-1">
                            <span className="me-2"><strong>City:</strong> {selectedOrder.city || selectedOrder.parent?.city || "Hyderabad"}</span>
                            <span className="me-2"><strong>State:</strong> {selectedOrder.state || selectedOrder.parent?.state || "Telangana"}</span>
                            <span><strong>Pincode:</strong> {selectedOrder.pincode || selectedOrder.parent?.pincode || "--"}</span>
                            {selectedOrder.isAddressEdited && (
                              <span className="badge bg-info bg-opacity-25 text-primary border ms-2">Edited</span>
                            )}
                          </div>
                          <div className="text-muted small mt-1"><i className="bi bi-building me-1"></i>Campus: {selectedOrder.parent?.campus}</div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <h6 className="text-uppercase text-muted fw-bold mb-3 small border-bottom pb-2">Payment & Settlement</h6>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">Status:</span>
                          <span className={`badge ${selectedOrder.payments[0]?.status === 'PAID' ? 'bg-success' : 'bg-warning text-dark'}`}>{selectedOrder.payments[0]?.status}</span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">Settlement:</span>
                          <span className="badge bg-info">{selectedOrder.settlement_status}</span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <span className="text-muted">App Code:</span>
                          <span className="fw-bold">{selectedOrder.payments[0]?.applicationCode ?? "--"}</span>
                        </div>
                        
                        {!isVendor && !isStore && (
                          <div className="mt-4 p-3 bg-light rounded border">
                            <h6 className="fw-bold small mb-3">Administrative Actions</h6>
                            <Form.Group className="mb-2">
                              <Form.Label className="small fw-bold">Transaction Status</Form.Label>
                              <Form.Select size="sm" value={newStatus} onChange={(e) => setNewStatus(e.target.value)}>
                                <option value="FAILED">Failed</option>
                                <option value="PAID">Paid</option>
                              </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-2">
                              <Form.Label className="small fw-bold">Settlement Status</Form.Label>
                              <Form.Select size="sm" value={settlementStatus} onChange={(e) => setSettlementStatus(e.target.value)}>
                                <option value="PENDING">Pending</option>
                                <option value="SETTLED">Settled</option>
                                <option value="FAILED">Failed</option>
                              </Form.Select>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label className="small fw-bold">Application Code</Form.Label>
                              <Form.Control size="sm" type="text" placeholder="Enter code" value={applicationCode} onChange={(e) => setApplicationCode(e.target.value)} />
                            </Form.Group>
                          </div>
                        )}
                      </div>

                      <div className="col-12 mt-4">
                        <h6 className="text-uppercase text-muted fw-bold mb-3 small border-bottom pb-2">Order Items</h6>
                        <div className="table-responsive border rounded bg-white">
                          <table className="table table-sm table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr className="small">
                                <th>Student</th>
                                <th>USID</th>
                                <th>Class</th>
                                <th>Item Details</th>
                                <th className="text-end">Total Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedOrder.items?.map((item, index) => (
                                <React.Fragment key={index}>
                                  <tr className="table-primary opacity-75">
                                    <td className="fw-bold">{item.student?.studentName ?? "--"}</td>
                                    <td className="small">{item.student?.usid ?? "--"}</td>
                                    <td className="small">{item.student?.class} - {item.student?.section}</td>
                                    <td className="fw-bold small">
                                      <span className={`badge ${item.bundle?.isIndividualProduct ? 'bg-info text-white' : 'bg-warning text-dark'} me-2`}>
                                        {item.bundle?.isIndividualProduct ? 'Single Product' : 'Bundle'}
                                      </span>
                                      {item.bundle?.name}
                                    </td>
                                    <td className="text-end fw-bold small">₹{item.unitPrice ?? item.bundle?.totalPrice}</td>
                                  </tr>
                                  {item.orderItemProducts?.length > 0 &&
                                    item.orderItemProducts?.filter(p => p.totalQuantity > 0).map((product, pIndex) => (
                                      <tr key={`${index}-${pIndex}`} className="small">
                                        <td colSpan={3}></td>
                                        <td className="ps-4">
                                          <div className="d-flex align-items-center">
                                            <i className="bi bi-arrow-return-right me-2 text-muted"></i>
                                            <span>{product.product?.display_name || product.product?.name}</span>
                                            {product.size && <span className="badge bg-secondary ms-2">Size: {product.size}</span>}
                                            <span className="ms-2 text-muted">(Qty: {product.totalQuantity})</span>
                                          </div>
                                        </td>
                                        <td className="text-end text-muted small">
                                            ₹
                                            {(
                                                (item.bundle?.isIndividualProduct
                                                    ? product.product?.price
                                                    : product.product?.bundle_price) || 0
                                            ) * (product.totalQuantity || 0)}
                                        </td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="p-3 bg-light rounded border">
                          <label className="fw-bold small mb-2 d-block"><i className="bi bi-upc-scan me-2"></i>Shipping & Tracking</label>
                          <div className="row g-2">
                            <div className="col">
                              {isVendor ? (
                                <Form.Control size="sm" type="text" placeholder="Scan or enter barcode" value={barcode} onChange={(e) => setBarcode(e.target.value)} ref={barcodeInputRef} />
                              ) : (
                                <Form.Control size="sm" type="text" value={barcode || "No tracking ID assigned"} disabled />
                              )}
                            </div>
                            {isVendor && (
                              <div className="col-auto">
                                <Button variant="secondary" size="sm" onClick={() => barcodeInputRef.current?.focus()}>
                                  Focus
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="p-3 bg-light rounded border mt-3">
                          <Form.Group>
                            <Form.Label className="small fw-bold">Status Update Note (Optional)</Form.Label>
                            <Form.Control 
                              as="textarea" 
                              rows={2} 
                              size="sm" 
                              placeholder="Enter optional note for this status update" 
                              value={statusNote} 
                              onChange={(e) => setStatusNote(e.target.value)} 
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                  <Button variant="outline-secondary" size="sm" onClick={() => setShowModal(false)}>
                    Close
                  </Button>
                  <div className="ms-auto d-flex gap-2">
                    {(isSuperadmin || isAdmin) && selectedOrder?.transactionStatus === "PENDING" && (
                      <Button variant="outline-primary" size="sm" onClick={() => handleCheckIciciStatus(selectedOrder.id)}>
                        Check ICICI Status
                      </Button>
                    )}
                    {(selectedOrder?.status === "PACKED" || selectedOrder?.status === "DTDC_CANCELLED") && !selectedOrder?.trackingId && (
                      <Button variant="warning" size="sm" onClick={handleGenerateDtdc}>
                        Generate DTDC
                      </Button>
                    )}
                    {selectedOrder?.trackingId && selectedOrder?.status !== "CANCELLED" && selectedOrder?.status !== "DELIVERED" && selectedOrder?.status !== "RTO" && (
                      <Button variant="outline-danger" size="sm" onClick={handleCancelDtdc}>
                        Cancel DTDC
                      </Button>
                    )}
                    {selectedOrder?.trackingId &&  selectedOrder?.trackingId && selectedOrder?.status !== "CANCELLED" && selectedOrder?.status !== "DELIVERED" && (
                      <Button variant="outline-info" size="sm" onClick={() => handlePrintLabelClick(selectedOrder.id)}>
                        Print Label
                      </Button>
                    )}
                    {selectedOrder?.trackingId  && selectedOrder?.status !== "CANCELLED" && selectedOrder?.status !== "DELIVERED" && (
                      <Button variant="dark" size="sm" onClick={handleViewTracking} disabled={fetchingTracking}>
                        {fetchingTracking ? "Loading..." : "View Tracking"}
                      </Button>
                    )}
                    {canUpdateStatus && !isVendor && !isStore && !isAccounts && selectedOrder?.status !== "CANCELLED" && selectedOrder?.status !== "DELIVERED" && (
                      <Button variant="primary" size="sm" onClick={handleStatusUpdate} className="px-3">
                        Save Changes
                      </Button>
                    )}
                    {(isSuperadmin || isAdmin || isStore || isStoreAdmin) &&  !(/\/[ESM]/.test(selectedOrder?.orderId)) &&(
                      <Button variant="outline-dark" size="sm" onClick={() => setShowCopyModal(true)}>
                        Copy Order
                      </Button>
                    )}
                  </div>
                </Modal.Footer>
              </Modal>

              {/* Copy Order Modal */}
              <Modal show={showCopyModal} onHide={() => setShowCopyModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Generate Adjusted Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group>
                    <Form.Label>Select Adjustment Type:</Form.Label>
                    <Form.Check
                      type="radio"
                      label="Shoes (/S)"
                      name="copySuffix"
                      value="/S"
                      checked={copySuffix === "/S"}
                      onChange={(e) => setCopySuffix(e.target.value)}
                    />
                    <Form.Check
                      type="radio"
                      label="Exchange (/E)"
                      name="copySuffix"
                      value="/E"
                      checked={copySuffix === "/E"}
                      onChange={(e) => setCopySuffix(e.target.value)}
                    />
                    <Form.Check
                      type="radio"
                      label="Missing (/M)"
                      name="copySuffix"
                      value="/M"
                      checked={copySuffix === "/M"}
                      onChange={(e) => setCopySuffix(e.target.value)}
                    />
                  </Form.Group>
                  <p className="mt-3 text-muted small">
                    This will create a new order with ID: <strong>{selectedOrder?.orderId}{copySuffix}</strong> and amount <strong>₹0.01</strong>.
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowCopyModal(false)}>Cancel</Button>
                  <Button variant="primary" onClick={handleCopyOrder}>Generate</Button>
                </Modal.Footer>
              </Modal>

              {showDetailsModal && selectedOrderId && (
                <OrderDetails
                  orderId={selectedOrderId}
                  onHide={() => setShowDetailsModal(false)}
                  onOrderUpdate={getOrders}
                  setLoading={setLoading}
                  hideLoading={() => setLoading(false)}
                  orderStatusList={orderStatusList}
                />
              )}

              {showAddressModal && addressOrder && (
                <UpdateOrderAddressModal
                  show={showAddressModal}
                  onHide={() => {
                    setShowAddressModal(false);
                    setAddressOrder(null);
                  }}
                  order={addressOrder}
                  onSuccess={handleAddressUpdated}
                />
              )}
              
              <TrackingDetailsModal
                show={showTrackingModal}
                onHide={() => setShowTrackingModal(false)}
                trackingData={trackingData}
              />

              {/* PDF Preview Modal */}
              <Modal
                show={pdfPreview.show}
                onHide={() => setPdfPreview({ ...pdfPreview, show: false })}
                size="lg"
                centered
              >
                <Modal.Header closeButton className="bg-dark text-white">
                  <Modal.Title className="fw-bold">Order Slip</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh', padding: 0, backgroundColor: '#525659' }}>
                  {pdfPreview.url && (
                    <iframe
                      src={pdfPreview.url}
                      width="100%"
                      height="100%"
                      title="Order Slip"
                      style={{ border: 'none' }}
                    />
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" size="sm" onClick={() => setPdfPreview({ ...pdfPreview, show: false })}>
                    Close
                  </Button>
                  <Button variant="primary" size="sm" onClick={handleDownloadPdf} className="px-4">
                    Download PDF
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Label Selection Modal */}
              <LabelSelectionModal
                show={showLabelModal}
                onHide={() => setShowLabelModal(false)}
                onSelect={handlePrintLabel}
                options={labelOptions}
              />

              {/* Bulk Update Modal */}
              <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} centered size="lg">
                <Modal.Header closeButton className="bg-light">
                  <Modal.Title className="fw-bold">Bulk Update Status ({selectedOrders.length} orders)</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                  <div className="mb-4">
                    <h6 className="fw-bold small text-muted text-uppercase mb-3">Selected Orders</h6>
                    <div className="table-responsive border rounded shadow-sm" style={{ maxHeight: '250px' }}>
                      <table className="table table-sm table-hover align-middle mb-0">
                        <thead className="table-light sticky-top">
                          <tr className="small">
                            <th>Order ID</th>
                            <th>Student USID</th>
                            <th>Name</th>
                            <th>Current Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedOrders.map(orderId => {
                            const order = ordersMap[orderId] || orders.find(o => o.id === orderId);
                            return (
                              <tr key={orderId}>
                                <td className="fw-bold">{order?.orderId}</td>
                                <td className="small">{order?.studentUSIDs}</td>
                                <td className="small">{order?.studentNames}</td>
                                <td>
                                  <span className="badge bg-info text-capitalize small">
                                    {order?.status}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="text-danger p-0 border-0"
                                    onClick={() => handleSelectOrder(orderId)}
                                    title="Remove from selection"
                                  >
                                    <i className="bi bi-x-circle-fill fs-6"></i>
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <hr />
                  
                  <div className="bg-light p-3 rounded border">
                    <h6 className="fw-bold mb-3">New Delivery Status</h6>
                    <Form.Group className="mb-3">
                      <Form.Select
                        value={bulkStatus}
                        onChange={(e) => setBulkStatus(e.target.value)}
                        className="form-select-lg"
                      >
                        <option value="">-- Choose New Status --</option>
                        {(() => {
                          const minCurrentOrder = Math.min(...selectedOrders.map(id => {
                            const order = ordersMap[id] || orders.find(o => o.id === id);
                            const statusObj = statusSequence.find(s => s.key === (order?.status || "IN_PROGRESS"));
                            return statusObj ? statusObj.order : 1;
                          }));

                          return orderStatusList
                            .filter(s => {
                              const targetObj = statusSequence.find(seq => seq.key === s.name);
                              if (user?.role === ROLES.SUPER_ADMIN) return !!targetObj;
                              return targetObj && targetObj.order > minCurrentOrder;
                            })
                            .sort((a, b) => {
                              const orderA = statusSequence.find(seq => seq.key === a.name)?.order || 0;
                              const orderB = statusSequence.find(seq => seq.key === b.name)?.order || 0;
                              return orderA - orderB;
                            })
                            .map(status => (
                              <option key={status.name} value={status.name}>
                                {status.displayName}
                              </option>
                            ));
                        })()}
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Only statuses ahead of the earliest current status among selected orders are shown.
                      </Form.Text>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label className="small fw-bold">Bulk Update Note (Optional)</Form.Label>
                      <Form.Control 
                        as="textarea" 
                        rows={2} 
                        placeholder="Enter optional note for all selected orders" 
                        value={statusNote} 
                        onChange={(e) => setStatusNote(e.target.value)} 
                      />
                    </Form.Group>
                  </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                  <Button variant="secondary" size="sm" onClick={() => setShowBulkModal(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" size="sm" onClick={handleBulkStatusUpdate} disabled={!bulkStatus} className="px-4">
                    Update {selectedOrders.length} Orders
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Export CSV Options Modal */}
              <Modal show={showCsvPreviewModal} onHide={() => setShowCsvPreviewModal(false)} centered size="xl">
                <Modal.Header closeButton className="bg-primary text-white">
                  <Modal.Title className="fw-bold">CSV Bulk Update Preview ({csvData.length} orders)</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                  <div className="mb-4">
                    <h6 className="fw-bold small text-muted text-uppercase mb-3">Orders from CSV</h6>
                    <div className="table-responsive border rounded shadow-sm" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      <table className="table table-sm table-hover align-middle mb-0">
                        <thead className="table-light sticky-top">
                          <tr className="small">
                            {csvHeaders.map(header => <th key={header}>{header}</th>)}
                            <th>Details from Database</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingPreview ? (
                            <tr>
                              <td colSpan={csvHeaders.length + 1} className="text-center py-4">
                                <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                                Fetching order details...
                              </td>
                            </tr>
                          ) : csvData.map((row, index) => {
                            const detail = previewDetails.find(d => d.orderId === row['Order ID']);
                            return (
                              <tr key={index}>
                                {csvHeaders.map(header => <td key={header}>{row[header]}</td>)}
                                <td>
                                  {detail ? (
                                    <div className="small">
                                      <div className="fw-bold">usid :  {detail.studentUSIDs} | {detail.studentNames}</div>
                                      <div className="text-muted">
                                        Status: <span className="badge bg-info p-1">{detail.status}</span> | 
                                      </div>
                                    </div>
                                  ) : (
                                    <span className="text-danger small">Order not found in database</span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <hr />
                  
                  <div className="bg-light p-3 rounded border">
                    <h6 className="fw-bold mb-3">Update to New Status</h6>
                    <Form.Group>
                      <Form.Select
                        value={bulkUploadStatus}
                        onChange={(e) => setBulkUploadStatus(e.target.value)}
                        className="form-select-lg"
                      >
                         <option value="">-- Choose New Status --</option>
                         {orderStatusList.map(status => (
                            <option key={status.name} value={status.name}>
                              {status.displayName}  
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                  <Button variant="secondary" size="sm" onClick={() => setShowCsvPreviewModal(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" size="sm" onClick={handleCsvBulkUpdate} disabled={!bulkUploadStatus || loadingPreview} className="px-4">
                    Update All {csvData.length} Orders
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Export CSV Options Modal */}
              <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
                <Modal.Header closeButton className="bg-success text-white">
                  <Modal.Title className="fw-bold">Export CSV Options</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                  <p className="text-muted mb-4">Please choose which products you want to export:</p>
                  <div className="d-grid gap-3">
                    <Button 
                      variant="outline-success" 
                      className="py-3 fw-bold d-flex align-items-center justify-content-between text-start"
                      onClick={() => {
                        setShowExportModal(false);
                        exportToCSVNew('non-shoes');
                      }}
                    >
                      <span><i className="bi bi-box-seam me-2"></i> All Products (Excluding Shoes)</span>
                      <i className="bi bi-chevron-right"></i>
                    </Button>
                    <Button 
                      variant="outline-success" 
                      className="py-3 fw-bold d-flex align-items-center justify-content-between text-start"
                      onClick={() => {
                        setShowExportModal(false);
                        exportToCSVNew('shoes');
                      }}
                    >
                      <span><i className="bi bi-person-walking me-2"></i> Only Shoes Orders</span>
                      <i className="bi bi-chevron-right"></i>
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderManagement;

const TrackingDetailsModal = ({ show, onHide, trackingData }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>DTDC Tracking Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {trackingData && trackingData.status === "SUCCESS" ? (
          <div>
            <div className="mb-4 p-3 bg-light rounded border">
              <div className="row">
                <div className="col-md-6">
                  <p className="mb-1"><strong>AWB Number:</strong> {trackingData.trackHeader?.strcnno}</p>
                  <p className="mb-1"><strong>Status:</strong> <span className="badge bg-primary">{trackingData.trackHeader?.strStatus}</span></p>
                </div>
                <div className="col-md-6">
                  <p className="mb-1"><strong>Origin:</strong> {trackingData.trackHeader?.strOrigin}</p>
                  <p className="mb-1"><strong>Destination:</strong> {trackingData.trackHeader?.strDest}</p>
                </div>
              </div>
            </div>

            <h6 className="fw-bold mb-3">Tracking History</h6>
            <div className="table-responsive">
              <Table striped bordered hover size="sm">
                <thead className="table-light">
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Location</th>
                    <th>Activity</th>
                  </tr>
                </thead>
                <tbody>
                  {trackingData.trackDetails && trackingData.trackDetails.length > 0 ? (
                    trackingData.trackDetails.map((detail, index) => (
                      <tr key={index}>
                        <td>{detail.strActionDate}</td>
                        <td>{detail.strActionTime}</td>
                        <td>{detail.strLocation}</td>
                        <td>{detail.strAction}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">No history available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <p className="text-center text-muted py-4">
            {trackingData?.message || "No tracking information found for this AWB."}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
